/* eslint-disable react/prefer-stateless-function */
import React, { type FunctionComponent } from 'react'
import { useIntl } from 'react-intl'
import { TextField } from 'ic-snacks'
import { type FormikProps } from 'formik'
import {
  type ProductFormValues,
  type NewProductFormValues,
} from 'legacy/routes/catalog/types/product.types'
import FormSection from './FormSection'
import ProductTypeInfoModal from './ProductTypeInfoModal'
import FormField from 'legacy/routes/catalog/products/product/form-components/FormField'
type Props = {
  disabled?: boolean
} & (FormikProps<ProductFormValues> | FormikProps<NewProductFormValues>)

export const ProductCodes: FunctionComponent<Props> = ({
  handleChange,
  values,
  disabled,
  errors,
  touched,
}) => {
  const intl = useIntl()

  return (
    <FormSection
      titleId="catalog.product.codes"
      renderAction={() => (values.editable ? null : <ProductTypeInfoModal />)}
    >
      <label>
        {intl.formatMessage({
          id: 'catalog.product.codes.note',
        })}
      </label>
      <FormField>
        <TextField
          fullWidth
          floatingLabelText={intl.formatMessage({
            id: 'catalog.product.upcCodes.label',
          })}
          name="productCodes"
          type="text"
          disabled={disabled}
          isValid={!errors.productCodes || !touched.productCodes}
          hasError={Boolean(errors.productCodes && touched.productCodes)}
          validationErrorText={errors.productCodes}
          onChange={handleChange}
          value={values.productCodes}
        />
      </FormField>
      <FormField>
        <TextField
          fullWidth
          floatingLabelText={intl.formatMessage({
            id: 'catalog.product.rrcCodes.label',
          })}
          name="retailerReferenceCode"
          type="text"
          disabled={disabled}
          isValid={!errors.productCodes || !touched.productCodes}
          hasError={Boolean(errors.productCodes && touched.productCodes)}
          validationErrorText={errors.productCodes}
          onChange={handleChange}
          value={values.retailerReferenceCode}
        />
      </FormField>
    </FormSection>
  )
}
